/**
 * Web stub for react-native-vision-camera.
 *
 * QRScannerModal.tsx guards the native path with Platform.OS !== 'web'
 * (and uses html5-qrcode instead on web), so these exports are never
 * actually rendered — they exist only so Vite's module resolver has
 * something to bind against during the web bundle.
 */
import React from 'react';

export function Camera(_props: any) {
  return null;
}
export function useCameraDevice(_position?: string) {
  return null;
}
export function useCameraPermission() {
  return { hasPermission: false, requestPermission: async () => false };
}
export function useCodeScanner(_opts?: any) {
  return undefined;
}
